import { render, staticRenderFns } from "./LabelField.vue?vue&type=template&id=10314f41&"
import script from "./LabelField.vue?vue&type=script&lang=ts&"
export * from "./LabelField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports